export default __webpack_public_path__ + "static/media/arrow-right-grey.4d2bf623.svg";